`<template>
  <v-container fluid class="pa-0 main-page">
    <v-row class="ma-0 pt-8 pb-10 bg-main info-card" v-if="user">
      <v-col class="pa-0">
        <v-card class="mx-auto" elevation="0" width="960" color="transparent">
          <v-list-item class="pa-0 px-6 px-md-0 mb-5">
            <v-list-item-content class="pa-0">
              <v-list-item-title class="mb-3 name">
                {{ user.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="mb-2 email">{{
                user.email
              }}</v-list-item-subtitle>
              <v-list-item-subtitle class="mb-0 phone">{{
                user.phone
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <!-- PC -->
          <v-card-actions class="pa-0 d-none d-md-block">
            <v-row class="ma-0" align="end" justify="space-between">
              <v-col cols="auto" class="pa-0">
                <PopModifyBasic :user="user" @reset="getUser"></PopModifyBasic>
                <PopModify :name="user.name" :email="user.email"></PopModify>
                <PopSecede
                  :name="user.name"
                  :email="user.email"
                  :counter="counter"
                ></PopSecede>
              </v-col>
              <v-col cols="auto" class="pa-0 status">
                <v-row class="ma-0">
                  <v-col
                    v-for="(item, index) in counter"
                    :key="item.name"
                    cols="auto"
                    class="pa-0 px-4 text-center"
                    :style="{
                      borderRight: index == 0 ? '1px solid #b5d0eb' : '',
                    }"
                  >
                    <p class="status-title mb-0">{{ $t(item.name) }}</p>
                    <a class="status-count mb-0">{{ item.count }}</a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-actions>
          <!-- mobile & Tablet -->
          <v-card-actions class="pa-0 d-md-none">
            <v-row class="ma-0 mt-4">
              <v-row cols="auto" class="row pa-0 mt-4 mt-sm-1 justify-center">
                <PopModifyBasic :user="user" @reset="getUser"></PopModifyBasic>
                <PopModify :name="user.name" :email="user.email"></PopModify>
                <PopSecede
                  :name="user.name"
                  :email="user.email"
                  :counter="counter"
                ></PopSecede>
                <v-col cols="auto" class="pa-0 status">
                  <v-row class="ma-0">
                    <v-col
                      v-for="(item, index) in counter"
                      :key="item.name"
                      cols="auto"
                      class="pa-0 px-4 text-center"
                      :style="{
                        borderRight: index == 0 ? '1px solid #b5d0eb' : '',
                      }"
                    >
                      <p class="status-title mb-0">{{ item.name }}</p>
                      <a class="status-count mb-0">{{ item.count }}</a>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="ma-0 contents-wrap">
      <v-col class="pa-0">
        <v-card class="mx-auto tab-box-wrap" elevation="10" width="960">
          <v-tabs v-model="tab" class="mt-md-8">
            <v-tab class="px-4" v-for="item in tabItems" :key="item.name">{{
              $t(item.name)
            }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" class="mt-0 mb-0 mb-md-15">
            <v-tab-item
              class="tab-contents-wrap"
              v-for="item in tabItems"
              :key="item.component"
            >
              <component
                :is="item.component"
                :isCurrentTab="item == currentTab"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { API } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';
import { formatPhoneNumber } from '@/utils/filters';
import PopModify from '@/components/PopModify.vue';
import PopSecede from '@/components/PopSecede.vue';
import PopModifyBasic from '@/components/PopModifyBasic.vue';
export default {
  mixins: [DialogMixin, LoadingMixin],
  components: {
    PopModify,
    PopSecede,
    PopModifyBasic,
    MyApply: () => import('./tabItems/MyApply.vue'),
    MyQnA: () => import('./tabItems/MyQnA.vue'),
    MyAddStep: () => import('./tabItems/MyAddStep.vue'),
    MyResult: () => import('./tabItems/MyResult.vue'),
    MyAgree: () => import('./tabItems/MyAgree.vue'),
  },
  data() {
    return {
      counter: [],
      user: null,
      loading: false,

      tab: null,
      tabItems: [
        {
          name: '나의 지원현황',
          component: 'MyApply',
        },
        {
          name: 'Q&A',
          component: 'MyQnA',
        },
        {
          name: '전형 안내 및 결과 확인',
          component: 'MyResult',
        },
        {
          name: '과제제출 및 추가정보 입력',
          component: 'MyAddStep',
        },
        // {
        //   name: '확인서 출력',
        //   component: 'MyAgree',
        // },
      ],
    };
  },
  computed: {
    currentTab() {
      return this.tabItems[this.tab];
    },
  },
  created() {
    this.getUser();
  },
  mouted() {
    this.tab = 0;
  },
  methods: {
    async getUser() {
      this.showLoading();
      try {
        const { data } = await API.getAuthJson('/user/info', {});
        this.user = {
          name: data.name,
          email: data.email,
          phone: formatPhoneNumber(data.phone),
        };

        this.counter = data.counter ?? [];
      } catch (error) {
        console.error(error);
      } finally {
        this.hideLoading();
      }
    },
  },
};
</script>
<style lang="scss">
@import './main.scss';
</style>
